import { render, staticRenderFns } from "./newShepaLink.vue?vue&type=template&id=7708d56a"
import script from "./newShepaLink.vue?vue&type=script&lang=js"
export * from "./newShepaLink.vue?vue&type=script&lang=js"
import style0 from "./newShepaLink.vue?vue&type=style&index=0&id=7708d56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports